"use strict";

const { Duration } = require("luxon");

const COMPARISON_TIME_UNIT_MAP = {
  previousDay: "days",
  previousWeek: "weeks",
  previousMonth: "months",
  previousQuarter: "quarters",
  previousYear: "years"
};

/**
 * Gets a Luxon duration offset, based on comparisonRange
 */
const getComparisonOffset = (result, props) => {
  const { startDate, endDate } = result;
  const { dateDuration, mode, comparisonRange } = props;

  if (comparisonRange === "previous") {
    if (mode === "rolling") {
      return Duration.fromISO(dateDuration);
    }
    return endDate.diff(startDate);
  }

  return Duration.fromObject({
    [COMPARISON_TIME_UNIT_MAP[comparisonRange]]: 1
  });
};

/**
 * When comparisonRange has a value, transpose the dates back to the comparison date-range.
 */
const getComparisonDates = (result, props) => {
  const { startDate, endDate } = result;
  const { comparisonRange } = props;

  if (!comparisonRange) {
    return result;
  }

  const comparisonOffset = getComparisonOffset(result, props);

  return {
    startDate: startDate.minus(comparisonOffset),
    endDate: endDate.minus(comparisonOffset)
  };
};

module.exports = getComparisonDates;
